module.exports = "/** Product **/\n\n.product-description {\n  font-size: 14px;\n  color: #FFFFFF;\n  line-height: 21px;\n  white-space: pre-wrap;\n}\n"